import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { getLocationImage, getLocationDrawImages } from 'tripPlanner/api'
import { LocationDrawImagesRequest } from 'tripPlanner/api/types'
import * as LocationImageKeys from '../reactQueryKeys/locationImage'

export type ActivityLocationImage = {
  id: string
  name: string
  placeId: string
  imageIds: Array<string>
}

export const useLocationImage = (
  placeId: string | undefined,
): UseQueryResult<Array<ActivityLocationImage>> => {
  return useQuery({
    queryKey: LocationImageKeys.locationImage(placeId || ''),
    queryFn: () => getLocationImage(placeId || ''),
    enabled: !!placeId,
  })
}

export type LocationDrawImagesData = LocationDrawImagesRequest | undefined

export const useLocationDrawImages = (
  locationData: LocationDrawImagesData,
): UseQueryResult<Array<string>> => {
  return useQuery({
    queryKey: LocationImageKeys.locationDrawImages(
      locationData?.title ?? '',
      locationData?.description,
      locationData?.emoji,
      locationData?.searchHelper,
    ),
    queryFn: async() => {
      if (!locationData) return []
      const result = await getLocationDrawImages(locationData)
      return result.imageIds ?? result.imageUrls ?? []
    },
    enabled: !!locationData,
  })
}
